import React from 'react';
import Header from '../Header';
import MenuControl, { MenuControlKey } from '../Header/MenuControl';
import ChatControl, { ChatControlKey } from '../Header/ChatControl';
import { getGridViewOpenState } from '../../selectors';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useIsWhiteboardOpen } from '../../hooks/useIsWhiteboardOpen';
const HeaderCallFrame = () => {
    const isGridOpen = useSelector(getGridViewOpenState);
    const isWhiteboardOpen = useIsWhiteboardOpen();
    const title = isWhiteboardOpen ? 'extensions.whiteboard.title' : null;
    if (!isGridOpen) {
        return null;
    }
    return (<Header leftControls={[<MenuControl key={MenuControlKey}/>]} title={title && <FormattedMessage id={title}/>} rightControls={[<ChatControl key={ChatControlKey}/>]}/>);
};
export default HeaderCallFrame;
